import { render, staticRenderFns } from "./PricingRule.vue?vue&type=template&id=226c3b53&scoped=true&"
import script from "./PricingRule.vue?vue&type=script&lang=js&"
export * from "./PricingRule.vue?vue&type=script&lang=js&"
import style0 from "./PricingRule.vue?vue&type=style&index=0&id=226c3b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226c3b53",
  null
  
)

export default component.exports